export function secondsToTime(rawSeconds: number) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);

    return { hours, minutes, seconds };
}